var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.41 1.25 12.75 1.59 12.75 2V4.8C12.75 5.21 12.41 5.55 12 5.55H8C7.59 5.55 7.25 5.21 7.25 4.8V2C7.25 1.59 7.59 1.25 8 1.25H12ZM12 0H8C6.9 0 6 0.9 6 2V4.8C6 5.9 6.9 6.8 8 6.8H12C13.1 6.8 14 5.9 14 4.8V2C14 0.9 13.1 0 12 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.4502C6.41 14.4502 6.75 14.7902 6.75 15.2002V18.0002C6.75 18.4102 6.41 18.7502 6 18.7502H2C1.59 18.7502 1.25 18.4102 1.25 18.0002V15.2002C1.25 14.7902 1.59 14.4502 2 14.4502H6ZM6 13.2002H2C0.9 13.2002 0 14.1002 0 15.2002V18.0002C0 19.1002 0.9 20.0002 2 20.0002H6C7.1 20.0002 8 19.1002 8 18.0002V15.2002C8 14.1002 7.1 13.2002 6 13.2002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.4502C18.41 14.4502 18.75 14.7902 18.75 15.2002V18.0002C18.75 18.4102 18.41 18.7502 18 18.7502H14C13.59 18.7502 13.25 18.4102 13.25 18.0002V15.2002C13.25 14.7902 13.59 14.4502 14 14.4502H18ZM18 13.2002H14C12.9 13.2002 12 14.1002 12 15.2002V18.0002C12 19.1002 12.9 20.0002 14 20.0002H18C19.1 20.0002 20 19.1002 20 18.0002V15.2002C20 14.1002 19.1 13.2002 18 13.2002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.52V11C4 10.45 4.43 10 4.96 10H15.04C15.57 10 16 10.45 16 11V13.52",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.24023V10.0002",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeManagerIcon);
export default __webpack_public_path__ + "static/media/nodeManagerIcon.3820dac8d56c6b3d8d5c801d743feb91.svg";
export { ForwardRef as ReactComponent };